import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1C2.79086 1 1 2.79086 1 5V15C1 17.2091 2.79086 19 5 19H15C17.2091 19 19 17.2091 19 15V5C19 2.79086 17.2091 1 15 1H5ZM14.7681 7.23101C14.4588 6.923 13.9573 6.923 13.648 7.23101L8.7625 12.0958L6.35229 9.6958C6.04296 9.38778 5.54144 9.38778 5.23212 9.6958C4.92279 10.0038 4.92279 10.5032 5.23212 10.8112L8.20241 13.769C8.51174 14.077 9.01326 14.077 9.32258 13.769L14.7681 8.34645C15.0775 8.03843 15.0775 7.53903 14.7681 7.23101Z"
      fill={fill}
      transform="translate(2 2)"
    />
  </g>
);

export default Icon;
